export default {"src":"/_next/static/media/star-icon.f90da48d.svg","height":20,"width":20};